import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { applyFilters } from "../../store/rankings.actions"
import { getActiveFilters, getWHWFilterData } from "../../store/rankings.selectors"
import { AwardsCategoryFilterBox } from "../../styles"
import SelectInput from "../filters/selectInput"

const AwardsCategoryFilter = () => {
  const dispatch = useDispatch()
  const appliedFilters = useSelector(getActiveFilters)
  const filters = useSelector(getWHWFilterData)?.awards

  const handleSubmit = e => {
    dispatch(applyFilters({ award: e }))
  }

  return (
    <AwardsCategoryFilterBox>
      <SelectInput
        options={{
          id: "filter-category",
          label: "Awards Winners",
          items: filters || []
        }}
        isLoading={filters?.isLoading}
        filterValue={appliedFilters.award}
        onFilter={handleSubmit}
      />
    </AwardsCategoryFilterBox>
  )
}

export default AwardsCategoryFilter
